<template>
  <div id="ver-lojista" class="ver-dica">
    <div class="form-fields position-relative" v-if="getAffiliate !== null">
      <h1 class="title text-uppercase font-weight-bold">
        {{
          getAffiliate.status === AffiliateState.NOT_EVALUATED
            ? 'Ver afiliado'
            : 'Avaliar afiliado'
        }}
      </h1>
      <b-badge
        v-if="getAffiliate.status !== AffiliateState.NOT_EVALUATED"
        :variant="
          getAffiliate.status === AffiliateState.REPROVED ? 'danger' : 'success'
        "
      >
        {{
          getAffiliate.status === AffiliateState.REPROVED
            ? 'Reprovado'
            : 'Aprovado'
        }}
      </b-badge>
      <hr class="linha-amarela" />
      <div class="row">
        <div class="col-8 col-md-8 col-sm-12">
          <div class="form-group">
            <label for="cadastroRazaoSocial">Nome</label>
            <div
              class="text"
              id="cadastroRazaoSocial"
              v-if="getAffiliate.nome !== null"
            >
              {{ getAffiliate.nome }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-4" v-if="getAffiliate.cpf">
          <div class="form-group">
            <label for="cadastroCpf">CPF</label>
            <div class="text" id="cadastroCpf">
              {{ getAffiliate.cpf }}
            </div>
          </div>
        </div>
        <div class="col-4" v-if="getAffiliate.rg">
          <div class="form-group">
            <label for="cadastroRG">RG</label>
            <div class="text" id="cadastroRG">
              {{ getAffiliate.rg }}
            </div>
          </div>
        </div>

        <div class="col-4" v-if="getAffiliate.cnpj">
          <div class="form-group">
            <label for="cadastroCnpj">CNJP</label>
            <div class="text" id="cadastroCnpj">
              {{ getAffiliate.cnpj }}
            </div>
          </div>
        </div>
        <div class="col-8">
          <div class="form-group">
            <label for="cadastroEndereco">Endereço</label>
            <div
              class="text"
              id="cadastroEndereco"
              v-if="getAffiliate.endereco !== null"
            >
              {{ getAffiliate.endereco }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="cadastroNumero">Número</label>
            <div
              class="text"
              id="cadastroNumero"
              v-if="getAffiliate.numero !== null"
            >
              {{ getAffiliate.numero }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-5">
          <div class="form-group">
            <label for="cadastroComplemento">Complemento</label>
            <div
              class="text"
              id="cadastroComplemento"
              v-if="getAffiliate.complemento !== null"
            >
              {{ getAffiliate.complemento }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-2">
          <div class="form-group">
            <label for="cadastroCep">CEP</label>
            <div class="text" id="cadastroCep" v-if="getAffiliate.cep !== null">
              {{ getAffiliate.cep }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-5">
          <div class="form-group">
            <label for="cadastroBairro">Bairro</label>
            <div
              class="text"
              id="cadastroBairro"
              v-if="getAffiliate.bairro !== null"
            >
              {{ getAffiliate.bairro }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="cadastroCidade">Cidade</label>
            <div
              class="text"
              id="cadastroCidade"
              v-if="getAffiliate.cidade !== null"
            >
              {{ getAffiliate.cidade }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="cadastroEstado">UF</label>
            <div
              class="text"
              id="cadastroEstado"
              v-if="getAffiliate.estado !== null"
            >
              {{ getAffiliate.estado }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="cadastroCelular">Celular / Whatsapp</label>
            <div
              class="text"
              id="cadastroCelular"
              v-if="getAffiliate.celular !== null"
            >
              {{ getAffiliate.celular }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="cadastroTelefone">Telefone</label>
            <div
              class="text"
              id="cadastroTelefone"
              v-if="getAffiliate.telefone !== null"
            >
              {{ getAffiliate.telefone }}
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="cadastroTelefone">Carteira de clientes</label>
            <div class="text" id="cadastroTelefone">
              {{ getAffiliate.carteira_clientes === 0 ? 'Não' : 'Sim' }}
            </div>
          </div>
        </div>
        <div class="col-5">
          <div class="form-group">
            <label for="cadastroTelefone">Cidades de atuação</label>
            <div
              class="text"
              id="cadastroTelefone"
              v-if="getAffiliate.cidades_atuacao !== null"
            >
              <span
                v-for="(cidade_atuacao, index) in getAffiliate.cidades_atuacao"
                :key="index"
              >
                {{ cidade_atuacao.nome
                }}{{
                  !(index + 1 === getAffiliate.cidades_atuacao.length)
                    ? ','
                    : ''
                }}
              </span>
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-5">
          <div class="form-group">
            <label for="cadastroTelefone">Segmentos de atuação</label>
            <div
              class="text"
              id="cadastroTelefone"
              v-if="getAffiliate.segmentos_atuacao !== null"
            >
              <span
                v-for="(
                  segmento_atuacao, index
                ) in getAffiliate.segmentos_atuacao"
                :key="index"
              >
                {{ segmento_atuacao.nome
                }}{{
                  !(index + 1 === getAffiliate.segmentos_atuacao.length)
                    ? ','
                    : ''
                }}
              </span>
            </div>
            <div class="text" id="id" v-else>Sem informação!</div>
          </div>
        </div>
        <div class="col-2 d-flex align-items-center justify-content-around">
          <div class="form-group" v-if="getAffiliate.curriculo !== null">
            <label>Currículo</label>
            <a
              :href="`${getImagesAddress}${getAffiliate.curriculo}`"
              class="d-flex align-items-center justify-content-around mt-2 c-pointer no-text-decoration c-orange"
              target="_blank"
              download
            >
              <i class="fas fa-file-pdf fs-24 c-orange"></i>
              <span>Baixar</span>
            </a>
          </div>
        </div>
        <div class="col-12" v-if="getAffiliate.resumo !== null">
          <div class="form-group">
            <label for="cadastroTelefone">Resumo</label>
            <div class="text" id="cadastroTelefone">
              {{ getAffiliate.resumo }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="cadastroEmail">E-mail</label>
            <div class="text" id="cadastroEmail">
              {{ getAffiliate.email }}
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <b-btn
          v-if="getAffiliate.status === AffiliateState.NOT_EVALUATED"
          class="btn-success"
          @click="approve(getAffiliate.id)"
        >
          Aprovar
        </b-btn>
        <b-btn
          v-if="getAffiliate.status === AffiliateState.NOT_EVALUATED"
          class="btn-danger ml-2"
          @click="$bvModal.show('reason')"
        >
          Rejeitar
        </b-btn>
        <button class="btn bg-orange ml-2 text-white" @click="backToList()">
          Voltar
        </button>
      </div>

      <b-modal
        title="Motivo da rejeição"
        size="xl"
        id="reason"
        header-bg-variant="orange"
        header-text-variant="light"
        centered
      >
        <div class="row container">
          <div class="col-12 col-md-12">
            <div class="form-group">
              <b-form-textarea
                type="text"
                class="form-control"
                placeholder="Descreva os motivos pelos quais você está rejeitando esse afiliado"
                rows="4"
                max-rows="10"
                v-model="Fields.reason"
                @input="errorMessages.reason = null"
              ></b-form-textarea>
              <p
                class="error-message text-danger"
                v-if="errorMessages.reason !== null"
              >
                {{ errorMessages.reason }}
              </p>
            </div>
          </div>
        </div>
        <template v-slot:modal-footer>
          <div class="w-100">
            <button
              type="button"
              class="btn btn-danger float-right"
              @click="reject(getAffiliate.id)"
            >
              <i class="fas fa-times mr-2"></i>
              Rejeitar
            </button>
          </div>
        </template>
      </b-modal>
    </div>
    <div class="form-fields" v-else>
      <h1 class="title text-uppercase">Esse afiliado não existe!</h1>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import makeToast from '../../../mixins/makeToast';
import AffiliateState from '../../../enums/Affiliate/AffiliateState';

export default {
  name: 'SeeAffiliate',
  mixins: [makeToast],
  props: ['id'],
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapGetters('affiliate', ['getAffiliate']),
  },
  data() {
    return {
      AffiliateState,
      Fields: {
        reason: null,
      },
      errorMessages: {
        reason: null,
      },
    };
  },
  created() {
    this.$store.dispatch('startLoader');
    this.get(this.id).finally(() => this.$store.dispatch('endLoader'));
  },
  methods: {
    ...mapActions('affiliate', ['get']),
    approve(affiliateId) {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('affiliate/approve', affiliateId)
        .then(() => {
          this.makeToast('Sucesso!', 'Afiliado aprovado com sucesso');

          this.get(affiliateId);
        })
        .catch(() => {
          this.makeToast(
            'Oopss!',
            'Houve um problema ao aprovar o afiliado',
            'danger'
          );
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    reject(affiliateId) {
      const data = {
        id: affiliateId,
        motivo: this.Fields.reason,
      };

      if (!data.motivo) {
        this.makeToast(
          'Atenção',
          'É necessário preencher o motivo pelo qual está rejeitando o afiliado',
          'warning'
        );

        return;
      }

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('affiliate/reject', data)
        .then(() => {
          this.makeToast('Sucesso!', 'Afiliado rejeitado com sucesso');

          this.get(affiliateId);
          this.$bvModal.hide('reason');
        })
        .catch(() => {
          this.makeToast(
            'Oopss!',
            'Houve um problema ao rejeitar o afiliado',
            'danger'
          );
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    backToList() {
      this.$router.push({
        name: 'administrador-afiliados',
      });
    },
  },
};
</script>

<style scoped>
@import '../../../custom/css/ver-dica.css';

.form-group label {
  font-weight: bold;
}
</style>
